import { Button, Grid, Paper, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import {
  Control,
  FieldErrors,
  UseFormRegister,
  UseFormReset,
} from "react-hook-form";
import WSSelectField from "../../Components/Select/WSSelect";
import WSTextField, { TextType } from "../../Components/TextBox/WSTextBox";
import WSTextAreaField from "../../Components/WSTextArea/WSTextArea";
import { callAPI, IRoleMain, IsSmallScreen, MasterPages, Method } from "../../commonFunctions/CommonFunctions";
import PermissionDenied from "../../commonFunctions/PermissionDenied";
import { getPermissions } from "../../commonFunctions/PermissionManger";
import WSRadioField from "../../Components/Radio/WSRadio";
import { WSIcons } from "../../commonFunctions/iIcons";
import WSDateField from "../../Components/DateField/WSDateField";
import WSImageUpload from "../../Components/FileUpload/WSImageUpload";

interface CashInHandProps {
  control: Control<any>;
  errors: FieldErrors;
  register: UseFormRegister<any>;
  id: any;
  reset: UseFormReset<any>;
  departmentId?: string;
  setValue: any;
}
const CashInHand: React.FC<CashInHandProps> = ({
  control, errors, register, id, reset, departmentId, setValue, }) => {
  const isMobile=IsSmallScreen()
  useEffect(
    () => () => {
      reset();
    },
    [id, reset]
  );

 
 
  return (
    <>
          <Grid  style={{paddingLeft:5,paddingRight:20,position:'relative',margin:0,marginTop:'3rem'}} container spacing={2}>
            <Grid item xs={12} sm={6}>
               <WSSelectField
                rules={{ required: true }}
                {...register("adjustment")}
                id="adjustment"
                control={control}
                isMobile={isMobile}
                label="Adjustment"
                name="adjustment"
              />
            </Grid>
             <Grid item xs={12} sm={6}>
                   <WSTextField
                                label={"Enter Amount"}
                                {...register("enterAmount")}
                                id="enterAmount"
                                name="enterAmount"
                                control={control}
                                rules={{ required: false }}
                              />
              
            </Grid>
              <Grid item xs={12} sm={6}>
               <WSDateField
                id="enterAdjustmentDate"
                name="enterAdjustmentDate"
                label={" Enter Adjustment Date "}
                dateFormat="DD-MM-YYYY"
                denyFuturOrPast="custom"
                control={control}
                rules={{ required: false }}
              />
        </Grid>
        <Grid item xs={12} >
                <WSTextAreaField
              label={"Description"}
              id={"description"}
              name={"description"}
              control={control}
              rules={{ required: false }}
              rows={3}
            />
        </Grid>
          </Grid>
          </>

  );
};
export default CashInHand;
